import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Box, Grid } from '@material-ui/core'
import clsx from 'clsx'
import EditableHTML from '@v4/components/common/EditableHTML'
import Image from '@v4/components/common/Image'
import ActionButton from '@v4/components/common/Buttons/ActionButton'
import SortHandler from '@v4/components/common/SortHandler'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EditableContainer from '@v4/components/common/EditableContainer'
import { useContent2 } from './Content2.hooks'

const Content2 = props => {
	const [
		{
			classes,
			image,
			withImage,
			withBgImage,
			withCenterImage,
			isMobile,

			buttonAction,
			buttonLink,
			buttonText,
			direction,
			text,
			textConfig,
			topText,
			topTextConfig,
			topTextEditable,
			textEditable,
			buttonTextEditable,
			buttonTextConfig,
			buttonTextKey,
			topTextKey,
			textKey,
		},
		{
			handleButtonClick,
			handleImageClick,
			handleTextClick,
			handleTopTextClick,
			handleTextChange,
			handleTopTextChange,
			handleButtonTextChange,
		},
	] = useContent2(props)

	return (
		<>
			{withBgImage && (
				<Image className={clsx(classes.background, 'content2-bg-image')} metaData={image} isBackground />
			)}
			<Grid className="content2" container justify="center" alignItems="center" spacing={isMobile ? 4 : 5}>
				<SortHandler key={isMobile ? 'mobile' : 'desktop'} direction={direction}>
					{withImage && (
						<Grid item lg={5} md={5} sm={12} xs={12} className="content2-image-container">
							<Box>
								<Image
									className={clsx(classes.image, 'content2-image')}
									metaData={image}
									onClick={handleImageClick}
								/>
							</Box>
						</Grid>
					)}
					<Grid item className={classes.empty} lg={1} md={1} />
					<Grid item lg={6} md={6} sm={12} xs={12} className="content2-content">
						<Box>
							<EditableContainer
								visible={!!topText}
								fieldConfig={topTextConfig}
								onAdd={handleTopTextChange}
								editable={topTextEditable}
								white={withBgImage}
							>
								<EditableHTML
									className={clsx(classes.title, 'content2-text-block-top')}
									html={topText}
									onClick={handleTopTextClick}
									editable={topTextEditable}
									onChange={handleTopTextChange}
									key={topTextKey}
									white={withBgImage}
								/>
							</EditableContainer>
							{withCenterImage && (
								<Image
									className={clsx(classes.centredImage, classes.image, 'content2-image-mobile')}
									metaData={image}
									onClick={handleImageClick}
								/>
							)}
							<EditableContainer
								visible={!!text}
								fieldConfig={textConfig}
								onAdd={handleTextChange}
								editable={textEditable}
								white={withBgImage}
							>
								<EditableHTML
									className={clsx(classes.text, 'content2-text-block-bottom')}
									html={text}
									onClick={handleTextClick}
									editable={textEditable}
									onChange={handleTextChange}
									key={textKey}
									white={withBgImage}
								/>
							</EditableContainer>
							<EditableContainer
								visible={!!buttonText}
								fieldConfig={buttonTextConfig}
								onAdd={handleButtonTextChange}
								editable={buttonTextEditable}
								label="Button"
								wrapper={({ children }) => (
									<Box width="100%" className={clsx(classes.buttonWrap, 'content2-button-wrapper')}>
										{children}
									</Box>
								)}
							>
								<ActionButton
									editable={buttonTextEditable}
									className={classes.button}
									action={buttonAction}
									href={buttonLink}
									onClick={handleButtonClick}
									onChange={handleButtonTextChange}
									key={buttonTextKey}
								>
									{buttonText}
								</ActionButton>
							</EditableContainer>
						</Box>
					</Grid>
				</SortHandler>
			</Grid>
		</>
	)
}

Content2.propTypes = {
	metaData: PropTypes.shape({
		topText: PropTypes.instanceOf(PageMetaData),
		text: PropTypes.instanceOf(PageMetaData),
		image: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		buttonLink: PropTypes.instanceOf(PageMetaData),
		buttonAction: PropTypes.instanceOf(PageMetaData),
		imagePosition: PropTypes.instanceOf(PageMetaData),
		mobileImage: PropTypes.instanceOf(PageMetaData),
		mobileImagePosition: PropTypes.instanceOf(PageMetaData),
		mobileOpacity: PropTypes.instanceOf(PageMetaData),
		mobileButtonWidth: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Content2)
